<script>
	import { onDestroy, getContext, createEventDispatcher } from 'svelte'
	import { styles } from '../library/scripts/styles'
	import { url } from '../library/scripts/Setup.svelte'
	import {
		storeElementID,
		storeData,
		storeShowTools,
		storeBuilderPreview,
		storeShowGallery,
	} from '../library/scripts/Store.svelte'

	import IntersectionObserver from 'svelte-intersection-observer'

	//observer
	let element
	let large = false
	const set_observer = (e) => {
		if (e === 'set') {
			element.style.filter = 'blur(5px)'
		} else {
			large = true
			element.style.filter = 'blur(0px)'
		}
	}

	const globals = getContext('globals')
	const fsS = globals.fsS
	const devWidth = globals.devWidth
	const isMobi = globals.mobi
	const builderToolbar = globals.builderToolbar
	const builderToolbarHover = globals.builderToolbarHover

	let folder
	if (!isMobi) {
		if (devWidth >= 1440) folder = '/large/'
		if (devWidth < 1440 && devWidth >= 800) folder = '/medium/'
		if (devWidth < 800) folder = '/small/'
	}

	// mobile devices
	if (isMobi) {
		if (devWidth < 1440 && devWidth >= 800) folder = '/medium/'
		else folder = '/small/'
	}

	let dispatch = createEventDispatcher()

	let configFile
	let data
	let showTools
	let showPreview

	const stoPreview = storeBuilderPreview.subscribe((value) => {
		showPreview = value
	})

	const stoData = storeData.subscribe((value) => {
		if (value) {
			configFile = value
			data = value.blocks
		}
	})

	const stoShowTools = storeShowTools.subscribe((value) => {
		showTools = value
	})

	let showGallery
	const stoShowGallery = storeShowGallery.subscribe((value) => {
		showGallery = value
	})

	let elementID = null

	const set_elementID = (e) => {
		storeShowTools.set(true)
		elementID = e
		storeElementID.set(e)
	}

	const show_gallery = () => {
		storeShowGallery.set(true)
		dispatch('opengallery')
	}

	onDestroy(() => {
		stoData
		stoShowTools
		stoPreview
		stoShowGallery
	})
</script>

<IntersectionObserver
	{element}
	threshold="0.5"
	on:observe={(e) => {
		if (!e.detail.isIntersecting) {
			set_observer('set')
		} else {
			set_observer('unset')
		}
	}}
>
	{#if configFile}
		<main id="galleryBlock" bind:this={element}>
			{#if !showPreview}
				<div
					class="content_row"
					use:styles={{ fsS, builderToolbar, builderToolbarHover }}
					on:click={() => set_elementID('gallery')}
					on:keydown={() => set_elementID('gallery')}
				>
					<div style="margin-left:20px;">*OPEN GALLERY TOOL*</div>
				</div>
			{/if}

			{#each data as block, index}
				{#if block.blockName === 'gallery'}
					<div
						class="gallery_container"
						style="
							margin-top:{block.marginTop}%;
							margin-bottom:{block.marginBottom}%;
							padding:{block.padding}%;
							border-top-left-radius : {block.borderTopRadius}px;
							border-top-right-radius : {block.borderTopRadius}px;
							border-bottom-left-radius: {block.borderBottomRadius}px;
							border-bottom-right-radius: {block.borderBottomRadius}px;
							border-left-width:{block.borderLeftWidth}px;
							border-left-style:{block.borderLeftStyle};
							border-left-color:{block.borderLeftColor};
							border-top-width:{block.borderTopWidth}px;
							border-top-style:{block.borderTopStyle};
							border-top-color:{block.borderTopColor};
							border-right-width:{block.borderRightWidth}px;
							border-right-style:{block.borderRightStyle};
							border-right-color:{block.borderRightColor};
							border-bottom-width:{block.borderBottomWidth}px;
							border-bottom-style: {block.borderBottomStyle};
							border-bottom-color:{block.borderBottomColor};
							background-color:{block.backgroundColor};
							background-image:{block.backgroundImage};
							background-size:{block.backgroundSize};
							background-repeat:{block.backgroundRepeat};
							box-shadow: 0px {block.galleryShadowY}px {block.galleryShadowBlur}px {block.galleryShadowColor};
							"
					>
						{#if block.blockTitle}
							{#if !showPreview}
								<div
									class="content_row"
									use:styles={{ fsS, builderToolbar, builderToolbarHover }}
									on:click={() => set_elementID(block.blockName + '_blockTitle')}
									on:keydown={() => set_elementID(block.blockName + '_blockTitle')}
								>
									<div style="margin-left:20px;">*OPEN TITLE TOOL*</div>
								</div>{/if}
							<div
								style="
								display:flex;
								width:{block.blockTitleWidth}%;
								min-height: {block.blockTitleHeight}px;
								justify-content:{block.blockTitleAlignHorizontal};
								align-items:{block.blockTitleAlignVertical};
								color:{block.blockTitleFontColor};
								background-color:{block.blockTitleBackgroundColor};
								font-family:{block.blockTitleFontFamily};
								font-size:{block.blockTitleFontSize};
								font-weight: {block.blockTitleFontWeight};
								font-style:{block.blockTitleFontStyle};
								text-decoration:{block.blockTitleFontDeco};
								margin-top:{block.blockTitleMarginTop}%;
								margin-bottom:{block.blockTitleMarginBottom}%;
								padding:{block.blockTitlePadding}%;
								text-shadow: {block.blockTitleShadowOffsetX}px {block.blockTitleShadowOffsetY}px {block.blockTitleShadowBlur}px  {block.blockTitleShadowColor};
								
								"
							>
								{block.blockTitle}
							</div>
						{/if}

						<div id="gallery_block" class="column_row">
							<div
								id={block.blockName + '_blockTitle'}
								style="
						display:flex;
						flex-direction:column;
						text-align:{block.galleryLeftAlign};
						justify-content:{block.galleryLeftValign};
						position:relative;
						width: 100%;
						padding : {block.galleryLeftPadding}%;
						margin-top: {block.galleryLeftMarginTop}%;
						margin-bottom: {block.galleryLeftMarginBottom}%;
						background-color : {block.galleryLeftBackgroundColor};
						border-top-left-radius : {block.galleryLeftBorderTopRadius}px;
						border-top-right-radius : {block.galleryLeftBorderTopRadius}px;
						border-bottom-left-radius: {block.galleryLeftBorderBottomRadius}px;
						border-bottom-right-radius: {block.galleryLeftBorderBottomRadius}px;
						border-background-image : {block.galleryLeftBorderBackgroundImage};
						border-left-width : {block.galleryLeftBorderLeftWidth}px;
						border-left-style : {block.galleryLeftBorderLeftStyle};
						border-left-color : {block.galleryLeftBorderLeftColor};
						border-top-width : {block.galleryLeftBorderTopWidth}px;
						border-top-style : {block.galleryLeftBorderTopStyle};
						border-top-color : {block.galleryLeftBorderTopColor};
						border-right-width : {block.galleryLeftBorderRightWidth}px;
						border-right-style : {block.galleryLeftBorderRightStyle};
						border-right-color : {block.galleryLeftBorderRightColor};
						border-bottom-width : {block.galleryLeftBorderBottomWidth}px;
						border-bottom-style : {block.galleryLeftBorderBottomStyle};
						border-bottom-color : {block.galleryLeftBorderBottomColor};
						background-image : {block.galleryLeftBackgroundImage};
						background-size:{block.galleryLeftBackgroundSize};
						background-repeat:{block.galleryLeftBackgroundRepeat};
						box-shadow: {block.galleryLeftShadowOffsetX}px {block.galleryLeftShadowOffsetY}px {block.galleryLeftShadowBlur}px {block.galleryLeftShadowColor};				
						color: {block.introFontColor};
						font-family:{block.introFontFamily};
						font-size:{block.introFontSize};
						font-weight:{block.introFontWeight};
						font-style:{block.introFontStyle};
						white-space:pre-wrap;
						"
							>
								{block.intro}
							</div>
							<div
								id="gallery_right_content"
								style="
									display:flex;
									align-items:{block.galleryRightValign};
									justify-content:{block.galleryRightAlign};
									position:relative;
									width: 100%;
									padding : {block.galleryRightPadding}%;
									margin-top: {block.galleryRightMarginTop}%;
									margin-bottom: {block.galleryRightMarginBottom}%;
									background-color : {block.galleryRightBackgroundColor};
									border-top-left-radius : {block.galleryRightBorderTopRadius}px;
									border-top-right-radius : {block.galleryRightBorderTopRadius}px;
									border-bottom-left-radius: {block.galleryRightBorderBottomRadius}px;
									border-bottom-right-radius: {block.galleryRightBorderBottomRadius}px;
									border-background-image : {block.galleryRightBorderBackgroundImage};
									border-left-width : {block.galleryRightBorderLeftWidth}px;
									border-left-style : {block.galleryRightBorderLeftStyle};
									border-left-color : {block.galleryRightBorderLeftColor};
									border-top-width : {block.galleryRightBorderTopWidth}px;
									border-top-style : {block.galleryRightBorderTopStyle};
									border-top-color :{block.galleryRightBorderTopColor};
									border-right-width : {block.galleryRightBorderRightWidth}px;
									border-right-style : {block.galleryRightBorderRightStyle};
									border-right-color : {block.galleryRightBorderRightColor};
									border-bottom-width : {block.galleryRightBorderBottomWidth}px;
									border-bottom-style : {block.galleryRightBorderBottomStyle};
									border-bottom-color : {block.galleryRightBorderBottomColor};
									background-image : {block.galleryRightBackgroundImage};
									background-size:{block.galleryRightBackgroundSize};
									background-repeat:{block.galleryRightBackgroundRepeat};
									box-shadow: {block.galleryRightShadowOffsetX}px {block.galleryRightShadowOffsetY}px {block.galleryRightShadowBlur}px {block.galleryRightShadowColor};
								"
							>
								<img
									data-imagehover
									on:click={show_gallery}
									on:keydown={show_gallery}
									id={block.blockName + '_image_' + block.content[(block.content.length - 1) / 2].image}
									style="
											width:{block.content[(block.content.length - 1) / 2].imageWidth}%;
											margin-top:{block.content[(block.content.length - 1) / 2].imageMarginTop}%;
											margin-bottom:{block.content[(block.content.length - 1) / 2].imageMarginBottom}%;
											padding:{block.content[(block.content.length - 1) / 2].imagePadding}%;
											object-fit:cover;
											cursor:pointer;
											box-shadow: {block.content[(block.content.length - 1) / 2].boxShadowX}px {block.content[(block.content.length - 1) / 2]
										.boxShadowY}px {block.content[(block.content.length - 1) / 2].boxShadowBlur}px {block.content[
										(block.content.length - 1) / 2
									].boxShadowColor};

											border-left: {block.content[(block.content.length - 1) / 2].imageBorderLeftWidth}px {block.content[
										(block.content.length - 1) / 2
									].imageBorderLeftStyle} {block.content[(block.content.length - 1) / 2].imageBorderLeftColor};

											border-top: {block.content[(block.content.length - 1) / 2].imageBorderTopWidth}px {block.content[
										(block.content.length - 1) / 2
									].imageBorderTopStyle} {block.content[(block.content.length - 1) / 2].imageBorderTopColor};

											border-right: {block.content[(block.content.length - 1) / 2].imageBorderRightWidth}px {block.content[
										(block.content.length - 1) / 2
									].imageBorderRightStyle} {block.content[(block.content.length - 1) / 2].imageBorderRightColor};

											border-bottom: {block.content[(block.content.length - 1) / 2].imageBorderBottomWidth}px {block.content[
										(block.content.length - 1) / 2
									].imageBorderBottomStyle} {block.content[(block.content.length - 1) / 2].imageBorderBottomColor};

											border-top-left-radius : {block.content[(block.content.length - 1) / 2].imageBorderTopRadius}px;
											border-top-right-radius : {block.content[(block.content.length - 1) / 2].imageBorderTopRadius}px;
											border-bottom-left-radius: {block.content[(block.content.length - 1) / 2].imageBorderBottomRadius}px;
											border-bottom-right-radius: {block.content[(block.content.length - 1) / 2].imageBorderBottomRadius}px;
										
											"
									src={url + '/' + block.blockName + folder + block.content[(block.content.length - 1) / 2].image}
									alt="col_img"
								/>
							</div>
						</div>
					</div>
				{/if}
			{/each}
		</main>
	{/if}
</IntersectionObserver>

<style>
	main {
		position: relative;
		user-select: none;
	}
	.column_row {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
		grid-gap: 0.5%;
	}

	.content_row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		width: 100%;
		cursor: pointer;
		font-style: italic;
		font-size: var(--fsS);
		background-color: var(--builderToolbar);
		height: 40px;
		border-bottom: 1px solid hsl(0, 0%, 50%);
	}

	.content_row:hover {
		background-color: var(--builderToolbarHover);
	}

	[data-imagehover]:hover {
		filter: brightness(120%);
	}
</style>
